module.exports = __webpack_public_path__ + "media/pricing/PGiftCardProduct-1a08fa69.png";